import { Card, SubTravelOptions } from '@/types/srp'

import { CabinMediaResource } from './types'

type PromoBannerResource =
    | string
    | { resourceUrl?: string; url?: string; displayTitle?: string; displaySubTitle?: string }

type PromoBanner = {
    title?: string
    baseResource?: string
    resources?: PromoBannerResource[]
}

type CabinClassSummary = {
    PREMIUM_ECONOMY?: {
        cabinPromoBanner?: PromoBanner | null
    }
}

const toResourceUrl = (resource: PromoBannerResource): string => {
    if (typeof resource === 'string') return resource
    return resource.resourceUrl ?? resource.url ?? ''
}

export const promoBannerToDrawerResources = (promoBanner?: PromoBanner | null): CabinMediaResource[] => {
    if (!promoBanner) return []

    const entries: CabinMediaResource[] = []
    const seenUrls = new Set<string>()

    const addResource = (resource: PromoBannerResource, fallbackTitle?: string) => {
        const resourceUrl = toResourceUrl(resource)
        if (!resourceUrl || seenUrls.has(resourceUrl)) return

        seenUrls.add(resourceUrl)
        const titledResource = typeof resource === 'object' ? resource : undefined

        entries.push({
            resourceUrl,
            displayTitle: titledResource?.displayTitle ?? fallbackTitle,
            displaySubTitle: titledResource?.displaySubTitle,
        })
    }

    if (promoBanner.baseResource) {
        addResource(promoBanner.baseResource, promoBanner.title)
    }

    ;(promoBanner.resources ?? []).forEach(resource => addResource(resource))

    return entries
}

export const getPeGalleryResourcesForCard = (
    card: Card | undefined,
    subTravelOptions: SubTravelOptions
): CabinMediaResource[] => {
    const subTravelOptionId = card?.subTravelOptionIds?.[0]
    if (!subTravelOptionId) return []

    const cabinClassSummary = (subTravelOptions[subTravelOptionId] as { cabinClassSummary?: CabinClassSummary })
        ?.cabinClassSummary
    const promoBanner = cabinClassSummary?.PREMIUM_ECONOMY?.cabinPromoBanner

    return promoBannerToDrawerResources(promoBanner)
}
